import React, { useEffect, useMemo, useState } from 'react'
import Header from '../include/Header'
import Sidebar from '../include/Sidebar'
import { Link, useNavigate } from 'react-router-dom'
import { PAY_URL } from '../../../BaseURL'
import axios from 'axios'
import toast from 'react-hot-toast'
import { Pagination, Search } from '../Table'
import Loader from '../include/Loader'
import Swal from 'sweetalert2'
import { Dropdown } from 'react-bootstrap'

const ProjectList = () => {

    const navigate = useNavigate();
    const [entity, setEntity] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [sorting, setSorting] = useState({ field: "", order: "" });
    const [limit, setlimit] = useState(10);
    const [disable, setDisable] = useState(true);

    useEffect(() => {
        if (localStorage.getItem('PAY_ADMIN_TOKEN') === null) {
            navigate("/admin/login");
        }

        if (disable === true) {
            setEntity([]);
            getProjectList();
        }
    }, [disable]);

    const itemsData = useMemo(() => {
        let computedItems = entity;

        if (search) {
            computedItems = computedItems.filter(
                (project) =>
                    project.name?.toLowerCase()?.includes(search?.toLowerCase()) ||
                    project.work_order_no?.toLowerCase()?.includes(search?.toLowerCase()) ||
                    project.firm_id?.name?.toLowerCase()?.includes(search?.toLowerCase())
            );
        }
        setTotalItems(computedItems.length);

        if (sorting.field) {
            const reversed = sorting.order === "asc" ? 1 : -1;
            computedItems = computedItems.sort(
                (a, b) => reversed * String(a[sorting.field]).localeCompare(String(b[sorting.field]))
            );
        }

        return computedItems?.slice(
            (currentPage - 1) * limit,
            (currentPage - 1) * limit + limit
        );
    }, [currentPage, search, sorting, limit, entity]);

    const getProjectList = () => {
        const myurl = `${PAY_URL}/admin/get-admin-project`;
        axios({
            method: "get",
            url: myurl,
            headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_ADMIN_TOKEN') },
        })
            .then(async (response) => {
                if (response?.data?.success) {
                    let data = await response?.data?.data?.map((e, i) => {
                        return { ...e, sr_no: i + 1 };
                    });

                    setEntity(data);
                    setDisable(false);
                } else {
                    toast.error("Something went wrong");
                }
            })
            .catch((error) => {
                toast.error("Something went wrong");
                console?.log("Errors", error);
                setDisable(false);
            });
    };

    const handleDelete = (id, title) => {
        Swal.fire({
            title: `Are you sure want to delete ${title}?`,
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {

                const myurl = `${PAY_URL}/admin/delete-project`;
                let bodyFormData = new URLSearchParams();
                bodyFormData.append("id", id);

                axios({
                    method: "delete",
                    url: myurl,
                    data: bodyFormData,
                    headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_ADMIN_TOKEN') },
                }).then((response) => {
                    if (response.data.success === true) {
                        toast.success(response?.data?.message);
                        setDisable(true);
                    } else {
                        toast.error(response?.data?.message);
                    }
                }).catch((error) => {
                    toast.error("Something went wrong");
                    console?.log("Errors", error);
                });
            }
        });
    }

    const handleRefresh = () => {
        setDisable(true)
    }

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    return (
        <>
            <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
                <Header handleOpen={handleOpen} />
                <Sidebar />

                <div className="page-wrapper">
                    <div className="content container-fluid">
                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title">Project Management</h3>
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to='/admin/dashboard'>Dashboard</Link></li>
                                        <li className="breadcrumb-item active">Project / Site</li>
                                    </ul>
                                </div>
                                <div className="col-auto float-end ms-auto">
                                    <Link to="/admin/manage-project" className="btn btn-primary"><i className="fa-solid fa-plus"></i> Add Project</Link>
                                </div>
                            </div>
                        </div>

                        <div className="row filter-row justify-content-end">
                            <div className="col-sm-12 col-md-8">
                                <div className="row justify-content-end">
                                    <div className="col-md-12 mb-2">
                                        <div className="justify-content-end d-flex align-center flex-wrap gap-2">
                                            <div className="seletePage d-flex gap-2 align-items-center ">
                                                <p className="mb-0">Rows per page:</p>
                                                <div className="d-flex align-items-center justify-content-center gap-2">
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            variant="none"
                                                            id="dropdown-basic"
                                                            style={{
                                                                cursor: "auto",
                                                                backgroundColor: "white",
                                                                borderColor: "#d5dbe0",
                                                                paddingBottom: "3px",
                                                                paddingTop: "3px",
                                                            }}
                                                            className='form-control selectWidth'
                                                        >
                                                            {limit}&nbsp;
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            {[10, 20, 30, 50].map((pageSize) => (
                                                                limit !== pageSize ? (
                                                                    <Dropdown.Item key={pageSize} onClick={() => setlimit(pageSize)}>
                                                                        {pageSize}
                                                                    </Dropdown.Item>
                                                                ) : null
                                                            ))}
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                    <div className="refreshPage">
                                                        <button className="btn btn-refresh-admin" type='button' onClick={handleRefresh}>
                                                            <i className="fa-solid fa-arrows-rotate"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tableSearch">
                                                <form action="">
                                                    <Search
                                                        onSearch={(value) => {
                                                            setSearch(value);
                                                            setCurrentPage(1);
                                                        }} />
                                                    <span className="search">
                                                        <i className="fa-solid fa-magnifying-glass"></i>
                                                    </span>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {disable === false ? (
                            <div className="card p-3">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-responsive">
                                            <table className="table table-striped custom-table mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Sr.</th>
                                                        <th>Firm</th>
                                                        <th>Name</th>
                                                        <th>Work Order No</th>
                                                        <th>Voucher No</th>
                                                        <th>Status</th>
                                                        <th className="text-end">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {itemsData.map((elem, i) =>
                                                        <tr key={elem?._id}>
                                                            <td>{elem?.sr_no}</td>
                                                            <td>{elem?.firm_id?.name || "-"}</td>
                                                            <td>{elem?.name}</td>
                                                            <td>{elem?.work_order_no}</td>
                                                            <td>{elem?.voucher_no}</td>
                                                            <td className='status-badge'>
                                                                {elem.status === true ? (
                                                                    <span className="badge text-bg-success">Active</span>
                                                                ) : (
                                                                    <span className="badge text-bg-danger">Inactive</span>
                                                                )}
                                                            </td>
                                                            <td className="text-end">
                                                                <div className="dropdown dropdown-action">
                                                                    <a href="#" className="action-icon dropdown-toggle"
                                                                        data-bs-toggle="dropdown" aria-expanded="false"><i
                                                                            className="material-icons">more_vert</i></a>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <button type='button' onClick={() => navigate('/admin/manage-project', { state: elem })} className="dropdown-item"><i
                                                                            className="fa-solid fa-pencil m-r-5"></i> Edit</button>
                                                                        <button type='button' className="dropdown-item" onClick={() => handleDelete(elem?._id, elem.name)}><i
                                                                            className="fa-regular fa-trash-can m-r-5"></i> Delete</button>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}

                                                    {itemsData?.length === 0 ? (
                                                        <tr>
                                                            <td colSpan="999">
                                                                <div className="no-table-data">
                                                                    No Data Found!
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                </tbody>
                                            </table>

                                        </div>
                                        <div className="row align-center mt-3 mb-2">
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                                                <div className="dataTables_info" id="DataTables_Table_0_info" role="status"
                                                    aria-live="polite">Showing {Math.min(limit, totalItems)} from {totalItems} data</div>
                                            </div>
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                                                <div className="dataTables_paginate paging_simple_numbers"
                                                    id="DataTables_Table_0_paginate">
                                                    <Pagination
                                                        total={totalItems}
                                                        itemsPerPage={limit}
                                                        currentPage={currentPage}
                                                        onPageChange={(page) => setCurrentPage(page)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : <Loader />}
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProjectList;
